import React from "react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "src/components/ui/table";
import { useGetPanelsQuery } from "../../endpoints/panel.endpoints";
import { Panel } from "../../types/panel.types";
import { formatDateTime } from "src/pages/billing/utils/billing-utils";

interface PanelTableProps {
  onOpenChange: (panel?: Panel) => void;
}

const PanelTable: React.FC<PanelTableProps> = ({ onOpenChange }) => {
  const { data: panels } = useGetPanelsQuery();

  return (
    <>
      <div className="w-full bg-white rounded-lg shadow-md overflow-hidden mt-4">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>
                Name
              </TableHead>
              <TableHead>
                Updated At
              </TableHead>
              <TableHead>
                Dimensions
              </TableHead>
              <TableHead>
                Users
              </TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {panels?.map((panel) => (
              <TableRow
                key={panel.id}
                className="cursor-pointer hover:bg-gray-200"
                onClick={() => onOpenChange(panel)}
              >
                <TableCell className="py-4">
                  {panel.name}
                </TableCell>
                <TableCell>
                  {formatDateTime(panel.updated_at)}
                </TableCell>
                <TableCell className="">
                  {panel.fields.filter((field) => field.status === 'active').length}
                </TableCell>
                <TableCell className="">
                  {panel.panelists || 0}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </>
  );
};

export default PanelTable;
